import React from "react";
import { BsDashLg } from "react-icons/bs";
import { Link } from "react-router-dom";
import roomCover from "../../../Assets/Hompage/Premium/premium (4).jpeg";
import roomCoverMobile from "../../../Assets/Room 4_mobile.jpg";
import premium from "../../../Assets/Hompage/Premium/premium (2).jpeg";
import deluxe from "../../../Assets/Hompage/deluxe/deluxe1 (3).jpg";
import UseTitle from "../../Hooks/UseTitle";
const AllRooms = () => {
  UseTitle("Room Details");
  return (
    <div className=" bg-gray-100">
      <div className="pt-16 md:pt-0 md:block hidden">
        <img className="w-full" src={roomCover} alt="room" />
      </div>
      <div className="pt-16 md:pt-0 md:hidden block">
        <img className="w-full" src={roomCoverMobile} alt="room" />
      </div>
      <div className="max-w-screen-xl mx-auto pb-10 md:px-10 px-8">
        <div className="mt-20">
          <div className="flex justify-center mx-auto">
            <div className="">
              <div className="flex justify-center md:justify-start nahid-title-designer">
                <h1
                  data-aos="fade-right"
                  data-aos-offset="300"
                  data-aos-easing="ease-in-sine"
                  className="md:text-[40px] text-[25px] text-center "
                >
                  Room features & facilities
                </h1>
              </div>
              <p className="text-[16px] mt-10 md:text-start text-justify">
                We have created a range of luxurious and cozy air-conditioned
                rooms, specifically designed with modern and elegant furniture
                to provide a warm and welcoming atmosphere for both business
                travelers and individual tourists. Our rooms are tastefully
                decorated to offer guests the ultimate comfort and convenience.
                Each of our stylish air-conditioned rooms features a spacious
                bathroom, equipped with hot and cold shower facilities, an
                intercom system, LED TV, 24-hour satellite channels, standard
                toiletries, freezer, uninterrupted internet connectivity and
                other amenities to ensure a pleasant stay.
              </p>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-10 my-20">
          <div className="bg-white">
            <h1 className="text-center my-10 text-[25px]">Deluxe </h1>
            <Link to="/Deluxe_Room" rel="noopener noreferrer">
              <img data-aos="zoom-in" src={deluxe} alt="deluxe" />
            </Link>
            <h1 className="text-center my-10 text-[25px]">
              <span className="text-gray-500">Rate</span>{" "}
              <span className="text-red-600">BDT 9,000++</span>
            </h1>
            <div className="mb-10 md:px-20 px-5">
              <p className="flex gap-6 items-center">
                <span className="md:text-4xl font-thin text-gray-400">
                  <BsDashLg />
                </span>
                <span className="md:text-[20px] text-gray-600 font-thin">
                  300 Sq. Ft
                </span>
              </p>
              <p className="flex gap-6 items-center">
                <span className="md:text-4xl text-gray-400">
                  <BsDashLg />
                </span>
                <span className="md:text-[20px] text-gray-600 font-thin">
                  Single Room.
                </span>
              </p>
              <p className="flex gap-6 items-center">
                <span className="md:text-4xl text-gray-400">
                  <BsDashLg />
                </span>
                <span className="md:text-[20px] text-gray-600 font-thin">
                  King Bed, Bathroom With Luxury Fittings
                </span>
              </p>
            </div>
            <button class="mb-10 hover:shadow-form bg-[#bb4f32] md:py-5 py-3 px-8 text-center text-[20px] font-semibold text-white outline-none">
              <Link to="/Online_Booking">Booking</Link>
            </button>
          </div>
          <div className="bg-white ">
            <h1 className="text-center my-10 text-[25px]">Premium </h1>
            <Link to="/Premium_Room">
              <img data-aos="zoom-in" src={premium} alt="premium" />
            </Link>
            <h1 className="text-center my-10 text-[25px]">
              <span className="text-gray-500">Rate</span>{" "}
              <span className="text-red-600">BDT 10,000++</span>
            </h1>
            <div className="mb-10 md:px-20 px-5">
              <p className="flex gap-6 items-center">
                <span className="md:text-4xl font-thin text-gray-400">
                  <BsDashLg />
                </span>
                <span className="md:text-[20px] text-gray-600 font-thin">
                  300 Sft.
                </span>
              </p>
              <p className="flex gap-6 items-center">
                <span className="md:text-4xl text-gray-400">
                  <BsDashLg />
                </span>
                <span className="md:text-[20px] text-gray-600 font-thin">
                  One Bed Room, 1 Bath, 1 Balcony.
                </span>
              </p>
              <p className="flex gap-6 items-center">
                <span className="md:text-4xl text-gray-400">
                  <BsDashLg />
                </span>
                <span className="md:text-[20px] text-gray-600 font-thin">
                  Garden View With one Spacious Balcony.
                </span>
              </p>
            </div>
            <button class="mb-10 hover:shadow-form bg-[#bb4f32] md:py-5 py-3 px-8 text-center text-[20px] font-semibold text-white outline-none">
              <Link to="/Online_Booking">Booking</Link>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllRooms;
